/**************************************************************************************************/
/*   File: /src/app/stores/states/index.ts                                                        */
/*   Project: newplan-frontend                                                                    */
/*   Created Date: Friday February 22nd 2019                                                      */
/*   Author: Andrea Zamboni andrea.zamboni@trilogis.it                                            */
/*   -----                                                                                        */
/*   Last Modified: Mon Apr 29 2019                                                               */
/*   Modified By: Andrea Zamboni                                                                  */
/*   -----                                                                                        */
/*   Copyright (c) 2019 Trilogis s.r.l. for SIAG                                                  */
/**************************************************************************************************/
import * as fromAuthorization from './authorization/index';
import * as fromDossiers from './dossiers/index';
import * as fromDownload from './download/index';
import * as fromCreation from './creation/index';
import * as fromDetails from './details/index';
import * as fromEditing from './editing/index';
import * as fromRoot from './root/index';
import * as fromUi from './ui/index';

export {
    fromAuthorization,
    fromRoot,
    fromDownload,
    fromCreation,
    fromDetails,
    fromEditing,
    fromUi,
    fromDossiers
};